import { render, staticRenderFns } from "./batchList.vue?vue&type=template&id=86a6fe6e&scoped=true&lang=html&"
import script from "./batchList.vue?vue&type=script&lang=js&"
export * from "./batchList.vue?vue&type=script&lang=js&"
import style0 from "./batchList.vue?vue&type=style&index=0&id=86a6fe6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a6fe6e",
  null
  
)

export default component.exports